import { Model } from 'app/model/backendmodel';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AdapterRegistry, Metamodel, Owned } from 'shell-models-lib';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { MountedRelationalDatabaseTableCopySink } from 'app/model/pipeline/copysink/mounted-relational-database-table.copysink';
import { TabularSinkAdapter } from 'app/model/adapters/activities/copysink/tabular.sink.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { MountedRelationalDatabaseOperationType } from 'app/registries/linked-service/mounted-relational-database-metadata';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MountedRelationalDatabaseTableCopySink),
    asynchronous: true,
    adapts: {
        type: '*',
        keyColumns: '*',
        operationType: '*',
        rowMarkerColumn: '*',
        defaultRowMarker: '*'
    }
})
export class MountedRelationalDatabaseTableCopySinkAdapter extends CopySinkAdapter<MountedRelationalDatabaseTableCopySink, Model.LakehouseTableSink> {
    protected override async _toResource(model: MountedRelationalDatabaseTableCopySink): Promise<Model.MountedRelationalDatabaseTableCopySink> {
        const result: Model.MountedRelationalDatabaseTableCopySink = {
            type: adfModelTypeMap.mountedRelationalDatabase.copySinkType
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.keyColumns = ValueAdapter.toResource(model, MountedRelationalDatabaseTableCopySink.WRITE_BEHAVIOR_KEYS);
        result.tableName = ValueAdapter.toResource(model, MountedRelationalDatabaseTableCopySink.TABLE_NAME);
        const operationType: MountedRelationalDatabaseOperationType = ValueAdapter.toResource(model, MountedRelationalDatabaseTableCopySink.OPERATION_TYPE);

        if (operationType === 'Column') {
            result.rowMarkerColumn  = ValueAdapter.toResource(model, MountedRelationalDatabaseTableCopySink.ROW_MARKER_COLUMN);
            result.defaultRowMarker = undefined;
        }
        else if (operationType === 'Default') {
            result.defaultRowMarker = ValueAdapter.toResource(model, MountedRelationalDatabaseTableCopySink.DEFAULT_ROW_MARKER);
            result.rowMarkerColumn = undefined;
        }
        else {
            result.rowMarkerColumn = undefined;
            result.defaultRowMarker = undefined;
        }
        
        return result;
    }

    protected override async _toModel(
        resource: Model.MountedRelationalDatabaseTableCopySink,
        copySink: CopySink
    ): Promise<MountedRelationalDatabaseTableCopySink> {
        const result = Owned.create<MountedRelationalDatabaseTableCopySink>(Metamodel.modelFor(MountedRelationalDatabaseTableCopySink), copySink);
        TabularSinkAdapter.toSinkModel(resource, result);
        ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.WRITE_BEHAVIOR_KEYS, resource.keyColumns);
        ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.TABLE_NAME, resource.tableName);
        
        if (!!resource.rowMarkerColumn) {
            ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.ROW_MARKER_COLUMN, resource.rowMarkerColumn);
            ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.OPERATION_TYPE, 'Column');
        }
        else if (!!resource.defaultRowMarker) {
            ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.DEFAULT_ROW_MARKER, resource.defaultRowMarker);
            ValueAdapter.toModel(result, MountedRelationalDatabaseTableCopySink.OPERATION_TYPE, 'Default');
        }

        return result;
    }
}
